import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';

const messagesListApi = new Api('jobs/:id/messages');

function* loadData({ payload }) {
  try {
    const { id, pageSize } = payload;
    const result = yield call(
      sendRequest,
      messagesListApi.load,
      { id, search: { pageSize } },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      const { data, totalCount, filteredCount, sortable_columns } = result.data;

      yield put(
        actions.loadDataSuccess({
          data,
          total: totalCount,
          filteredTotal: filteredCount,
          sortableColumns: sortable_columns,
        }),
      );
    }
  } catch (error) {
    logger.error(error);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, loadData)]);
}
